module.exports = __webpack_public_path__ + "img/108.cd2d3a39.png";